import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import { getReferralCallLogs } from "../../../service/Referral/action";
import SitesCallingLog from "./sitesCallingLog";


const mapStateToProps = (state) => ({
    referralCallLog:state.Referral.referralCallLog,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getReferralCallLogs
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(SitesCallingLog);
